// @ts-nocheck
export default defineNuxtPlugin(() => {
  const route = useRoute()
  if (route.query?.mc_cid) {
    window.localStorage.setItem('mc_cid', route.query.mc_cid)
    window.localStorage.setItem('mc_t', Date.now())
  }
})
